import React from 'react'
import ShoppingCart from '../components/ShoppingCart/ShoppingCart'
import { useCustomerDisplay } from '../context/CustomerDisplayContext'

export default function ShoppingCartPage() {
  const { productsCart, subtotal, itbms, total, priceChange } =
    useCustomerDisplay()

  return (
    <ShoppingCart
      products={productsCart}
      subtotal={subtotal}
      itbms={itbms}
      total={total}
      priceChange={priceChange}
    />
  )
}
